import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from '@/contexts/AuthContext';
import { Layout } from '@/components/layout/Layout';
import { HomePage } from '@/pages/HomePage';
import { AuthPage } from '@/pages/auth/AuthPage';
import { SearchPage } from '@/pages/SearchPage';
import { PublishPage } from '@/pages/listings/PublishPage';
import { ListingDetailPage } from '@/pages/listings/ListingDetailPage';
import { PromocionPublicaFacilPage } from '@/pages/landing/PromocionPublicaFacilPage';
import { ProfilePage } from '@/pages/profile/ProfilePage';
import { MessagesPage } from '@/pages/profile/MessagesPage';
import { AdminDashboardPage } from '@/pages/admin/AdminDashboardPage';
import { TermsPage } from '@/pages/legal/TermsPage';
import { PrivacyPage } from '@/pages/legal/PrivacyPage';
import { HelpPage } from '@/pages/HelpPage';

// Blog Pages
import { BlogPage } from '@/pages/blog/BlogPage';
import { BlogPostPage } from '@/pages/blog/BlogPostPage';
import { AdminBlogList } from '@/pages/admin/blog/AdminBlogList';
import { AdminBlogEditor } from '@/pages/admin/blog/AdminBlogEditor';

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/auth" element={<AuthPage />} />
              <Route path="/search" element={<SearchPage />} />
              <Route path="/listings/:id" element={<ListingDetailPage />} />
              <Route path="/publish" element={<PublishPage />} />
              
              {/* Blog Routes */}
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/blog/:slug" element={<BlogPostPage />} />
              
              {/* Perfil y Mensajes */}
              <Route path="/profile" element={<ProfilePage />} />
              <Route path="/profile/messages" element={<MessagesPage />} />
              
              {/* Ruta de Administración */}
              <Route path="/admin" element={<AdminDashboardPage />} />
              
              {/* Rutas de Gestión del Blog */}
              <Route path="/admin/blog" element={<AdminBlogList />} />
              <Route path="/admin/blog/new" element={<AdminBlogEditor />} />
              <Route path="/admin/blog/edit/:id" element={<AdminBlogEditor />} />
              
              {/* Páginas Legales y Ayuda */}
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/help" element={<HelpPage />} />
              
              {/* Landing Pages para Ads/SEO */}
              <Route path="/promocion-publica-facil" element={<PromocionPublicaFacilPage />} />
              
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Layout>
        </BrowserRouter>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
